/**
 * @generated SignedSource<<23d4c4d39a82302a1d150c51ce6b80f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "FondyRecurringResponse",
    "kind": "LinkedField",
    "name": "fondyRecurring",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FondyRecurringResponseInner",
        "kind": "LinkedField",
        "name": "response",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "confirmConfirmImplComponentsFondyRecurringMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "confirmConfirmImplComponentsFondyRecurringMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "01047cf72cf197498d79528afb33f19a",
    "id": null,
    "metadata": {},
    "name": "confirmConfirmImplComponentsFondyRecurringMutation",
    "operationKind": "mutation",
    "text": "mutation confirmConfirmImplComponentsFondyRecurringMutation(\n  $request: FondyRecurringRequestInput\n) {\n  fondyRecurring(request: $request) {\n    response {\n      responseStatus\n    }\n  }\n}\n"
  }
};
})();

node.hash = "a85567124fdd268ad3cb8d74329ab029";

module.exports = node;
